module.exports = __webpack_public_path__ + "img/arcanjo_miguel.5b6038bc.jpeg";